[
{
  "link": "/palavik",
  "name": "Palavik"
},
{
  "link": "/tuulerouged",
  "name": "Tuulerõuged"
},
{
  "link": "/kopsupoletik",
  "name": "Kopsupõletik"
},
{
  "link": "/korge-vererohk",
  "name": "Kõrge vererõhk"
},
{
  "link": "/diabeet",
  "name": "Diabeet"
},
{
  "link": "/kulmetus",
  "name": "Külmetus"
},
{
  "link": "/lapse-nohu",
  "name": "Lapse nohu"
},
{
  "link": "/lapse-koha",
  "name": "Lapse köha"
},
{
  "link": "/iiveldus",
  "name": "Iiveldus"
},
{
  "link": "/lakakoha",
  "name": "Läkaköha"
},
{
  "link": "/kohulahtisus",
  "name": "Kõhulahtisus"
},
{
  "link": "/korvetised",
  "name": "Kõrvetised"
},
{
  "link": "/valu",
  "name": "Valu"
},
{
  "link": "/seljavalu",
  "name": "Seljavalu"
},
{
  "link": "/peavalu",
  "name": "Peavalu"
},
{
  "link": "/kohuvalu",
  "name": "Kõhuvalu"
},
{
  "link": "/kurguvalu",
  "name": "Kurguvalu"
},
{
  "link": "/dermatiit",
  "name": "Dermatiit"
},
{
  "link": "/vaktsineerimine",
  "name": "Vaktsineerimine"
},
{
  "link": "/aneemia",
  "name": "Aneemia"
},
{
  "link": "/pearinglus",
  "name": "Pearinglus"
},
{
  "link": "/urineerimishaire",
  "name": "Urineerimishäire"
},
{
  "link": "/gripp",
  "name": "Gripp"
},
{
  "link": "/allergia",
  "name": "Allergia"
},
{
  "link": "/silmapoletik",
  "name": "Silmapõletik"
}]